import { Button } from "../../components/index.ts";

/**
 * A read of today's sessions failed after a good one: the last list stays on screen, with this note
 * and a way to read it again, so the owner never takes old marks as the current state.
 */
export function TodayStale({ onRetry }: { onRetry: () => void }) {
  return (
    <output className="flex items-center gap-2 text-[13px] text-late-ink">
      Not up to date.
      <Button size="sm" variant="ghost" onClick={onRetry}>
        Try again
      </Button>
    </output>
  );
}
